'use strict';


export function WistiaService($q, $http) {
  // Private methods
  /**
   * _httpHander(params, payload) - handles all http calls for the Wistia Factory
   *
   * @param {Object} params - an object containing the method, endpoint, id and options parameters
   * @param {Object} payload - an object containing the payload for POST/PUT requests
   * @returns {Promise} $http request promise.
   */
  function _httpHandler(params, payload) {
    // params.endpoint and params. is a minimal requirement,
    // One is the HTTP Method, one is the api enpoint
    if(!params.hasOwnProperty('endpoint') || !params.hasOwnProperty('method')) {
      return $q.reject({
        error: 'WISTIA_MISSING_ENDPOINT',
        message: 'params.endpoint and params.method is required in Wistia Service'
      });
    }

    // Define the minimum URL using params.endpoint
    let url = `/api/wistia/${params.endpoint}`;

    if(params.hasOwnProperty('id')) {
      url += `/${params.id}`;
    }

    // Define options
    let httpOpts = {
      url: url,
      method: params.method
    };
    // Add payload if it exists
    if(payload) {
      httpOpts.data = payload;
    }

    return $http(httpOpts); // Promise return
  }

  var self = {};

  // ======================
  // Wistia Events Methods
  // ======================
  self.events = {};
  /**
   * Wistia.events.get(id) - Get the info related to a specific Wistia event
   *
   * @param {String} id - The id of the event you are referencing
   * @returns {Promise}
   */
  self.events.get = function(id) {
    let params = {
      method: 'GET',
      endpoint: 'events',
      id: id
    };
    return _httpHandler(params);
  };


  return self;
}

export default angular.module('fplTruescapeComApp.Wistia', [])
  .factory('Wistia', WistiaService)
  .name;



// WEBPACK FOOTER //
// ./client/components/Wistia/Wistia.service.js